export default __webpack_public_path__ + "media/selection.d4579d34.svg";